import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const semiboldFontWeight = String(
    theme.fontWeightSemibold
  ) as TextStyle['fontWeight']

  return {
    base: {
      fontFamily: 'RDModern-SemiBold',
      fontWeight: semiboldFontWeight,
      textAlign: 'center',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      backgroundColor: 'transparent',
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      orientation: {
        vertical: {
          paddingTop: theme.spacingStackTwopulse,
          paddingLeft: theme.paddingInsetNone,
          paddingRight: theme.paddingInsetNone,
        },
        horizontal: {
          paddingLeft: theme.spacingStackTwopulse,
        },
      },
    },
  }
})
